import { Form } from '@ant-design/compatible'

// import '@ant-design/compatible/assets/index.css';

import { Modal, Switch } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import BulkEditForm from './BulkEditForm'
import PublicURLForm from '../library/PublicURLForm'
import '../styles/Tag.css'
import { rehostAssetUrl, validatePrivilege } from '../../dux/modules/utils'

class EditAssetModal extends React.Component {
  constructor(props) {
    super(props)

    this.saveTagsRef = (ref) => (this.tagsRef = ref)
    this.saveFormRef = (ref) => (this.form = ref)
    // For NEW assets, call the upload saga
    // For Existing assets, call the save edits saga
    this.saveEdits = () => {
      const { asset } = this.props.modalProps
      const datestring = moment().format('YYYYMMDD')
      // Save partial tag input, continue in callback from setstate
      this.tagsRef.handleInputConfirm(null, () => {
        this.form.validateFields((err, values) => {
          if (!err) {
            let updates = {
              updated: Date.now(),
              filename: values.filename,
              description:
                values.description &&
                values.description
                  .replace('%F', values.filename)
                  .replace('%D', datestring)
                  .replace('%I', '1'),
              title:
                values.title &&
                values.title
                  .replace('%F', values.filename)
                  .replace('%D', datestring)
                  .replace('%I', '1'),
              tags: this.tagsRef.getTags(),
            }

            const editedAsset = Object.assign({}, asset, updates)
            editedAsset.tags = this.tagsRef.getTags()
            this.props.modalProps.new
              ? this.props.assetActions.createAsset(
                  editedAsset,
                  this.props.folders.activeFolder,
                )
              : this.props.assetActions.saveAssetEdits(asset, updates)
          }
        })
      })
    }

    this.close = () => {
      if (this.props.modalProps.new) {
        // Delete that orphaned asset!
      } else {
        this.props.modalActions.closeModal()
      }
    }
  }

  // Publish privilege on the asset's folder gates the public-URL toggle
  allowPublicURL = () => {
    const { modalProps, permissions, user, folders } = this.props
    if (modalProps.new) return false
    if (!permissions || !user || !folders) return false

    return validatePrivilege(
      'publishasset',
      permissions.privileges,
      user.email,
      permissions.groups,
      folders.activeFolder,
      folders.byId,
    )
  }

  renderPublicURLSection = () => {
    if (!this.allowPublicURL()) return null

    const { modalProps, assets, assetActions, appState } = this.props
    // Read the live asset from state so the section reflects toggles
    // immediately (modalProps.asset is a snapshot from when the modal opened)
    const liveAsset =
      (assets && assets.byId && assets.byId[modalProps.asset.id]) ||
      modalProps.asset
    const enabled = !!liveAsset.publicURL

    return (
      <div style={styles.publicUrlContainer}>
        <div style={styles.publicUrlHeader}>
          <span style={styles.publicUrlLabel}>Public URL</span>
          <Switch
            checked={enabled}
            loading={appState && appState.asyncPending}
            onChange={(checked) =>
              assetActions.togglePublicLink(liveAsset, !checked)
            }
          />
        </div>
        {enabled && <PublicURLForm url={liveAsset.publicURL} />}
      </div>
    )
  }

  render() {
    return (
      <Modal
        title="Edit Asset Metadata"
        okText="SAVE"
        onOk={this.saveEdits}
        cancelText="Cancel"
        onCancel={this.props.modalActions.closeModal}
        open={this.props.modal.modalOpen}
        confirmLoading={this.props.appState.asyncPending}
        maskClosable={false}
      >
        <div className="modal__img-centered">
          {this.props.modalProps.asset.preview ? (
            <img
              src={`${rehostAssetUrl(
                this.props.modalProps.asset.preview,
              )}_thumb-200x`}
              alt={this.props.modalProps.asset.filename}
            />
          ) : (
            <i
              className={`fa fa-5x ${
                this.props.modalProps.asset.icon
                  ? this.props.modalProps.asset.icon
                  : 'fa-file-0'
              }`}
            />
          )}
        </div>
        <BulkEditForm
          ref={this.saveFormRef}
          assets={[this.props.modalProps.asset]}
          saveTagsRef={this.saveTagsRef}
          single={true}
        />
        {this.renderPublicURLSection()}
      </Modal>
    )
  }
}

const styles = {
  publicUrlContainer: {
    borderTop: '1px solid #f0f0f0',
    marginTop: '16px',
    paddingTop: '16px',
  },
  publicUrlHeader: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  publicUrlLabel: {
    fontWeight: 500,
  },
}

/*
 *  Props are from the redux store
 *  "actions" are objects created by bindActionCreators, containing all relevant action functions
 *  modalProps is object passed from modal creator
 */
EditAssetModal.propTypes = {
  modal: PropTypes.object,
  modalActions: PropTypes.object,
  folders: PropTypes.object,
  folderActions: PropTypes.object,
  assets: PropTypes.object,
  assetActions: PropTypes.object,
  modalProps: PropTypes.object,
}

EditAssetModal.defaultProps = {
  modalProps: {
    new: false,
  },
}

export default EditAssetModal
